import Swiper from 'swiper/bundle';

function initSwipers() {
  const swiperColor = new Swiper('.pdpn-swp_color', {
    slidesPerView: 'auto',
    mousewheel: true,
    freeMode: true,
    spaceBetween: 10,
  });


  const swiperImagesMobile = new Swiper('.pdpn-mobile-swp_images', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  })
  // Return the swipers so they can be accessed from outside of this file if necessary.
  return {
    swiperColor,
    swiperImagesMobile
  };
}

// call the function, so the swipers are initialized right away
initSwipers();

// Disclaimer to click on OOO sizes Optimization
const showDisclaimerSizesOOS = () => {
  const isMobile = window.innerWidth <= 768;
  if ( isMobile ) {
    const mainContainer = document.querySelector('.pdpn-main__container .title-disclaimer-container');
    const mobileContainer = mainContainer.querySelector('.disclaimer-oos-container.mobile-only');
    const disclaimerBell = mainContainer.querySelector('.disclaimer-oos-container:not(.mobile-only) svg');
    const closeButton = mobileContainer.querySelector('svg');
    const sizeLabels = document.querySelectorAll('.pdpn-main__container .pdpn-swp_size .pdpn-slide_label');


    if (disclaimerBell && mainContainer && mobileContainer) {
      disclaimerBell.addEventListener('click', e => {
        mainContainer.classList.add('padding-bottom');
        mobileContainer.classList.add('show');
      });
    }

    if (closeButton && mainContainer && mobileContainer) {
      closeButton.addEventListener('click', e => {
        mainContainer.classList.remove('padding-bottom');
        mobileContainer.classList.remove('show');
      });
    }

    if ( sizeLabels && mainContainer && mobileContainer) {
      sizeLabels.forEach(sizeLabel => {
        sizeLabel.addEventListener('click', e => {
          mainContainer.classList.remove('padding-bottom');
          mobileContainer.classList.remove('show');
        });
      });
    }
  }

}

document.addEventListener("DOMContentLoaded", function () {


  // main product form
  // shipping and returns
  let pdpnToggleShipping = document.getElementById("pdpnToggleShipping")
  let pdpnShippingContent = document.getElementById("pdpnShippingContent")

  pdpnToggleShipping.addEventListener('click', () => {
    if (pdpnShippingContent.style.display == 'none' || pdpnShippingContent.style.display == '') {
      pdpnShippingContent.style.display = 'block'
      pdpnToggleShipping.querySelector('.plus').style.display = 'none'
      pdpnToggleShipping.querySelector('.minus').style.display = 'inline'
    } else {
      pdpnShippingContent.style.display = 'none'
      pdpnToggleShipping.querySelector('.plus').style.display = 'inline'
      pdpnToggleShipping.querySelector('.minus').style.display = 'none'
    }
  })

  // product-images-new-pdp
  //  desktop
  const pdpnDeskImagesSwiperWrapper = document.querySelector('.pdpn-desktop-swp_carrousel_images')
  const pdpnDeskImagesSlides = document.querySelectorAll('.pdpn-desktop-swp-images_slide')
  const secondDesktopSlideIndex = 2

  let modelDesktopSlideIndex
  pdpnDeskImagesSlides.forEach((slide, index) => {
    const imagenElement = slide.querySelector('.pdpn-desktop-images_container img')
    if (imagenElement) {
      const imageAlt = imagenElement.getAttribute('alt')
      if (imagenElement && imageAlt.includes('[model]')) {
        modelDesktopSlideIndex = index + 1
      }
    }
  })

  if (modelDesktopSlideIndex && modelDesktopSlideIndex !== secondDesktopSlideIndex) {
    const secondSlide = pdpnDeskImagesSwiperWrapper.querySelector(`[data-pdpn-desktop-images-slide-index="${secondDesktopSlideIndex}"]`);
    const modelSlide = pdpnDeskImagesSwiperWrapper.querySelector(`[data-pdpn-desktop-images-slide-index="${modelDesktopSlideIndex}"]`);

    pdpnDeskImagesSwiperWrapper.insertBefore(modelSlide, secondSlide);
  }

  //mobile
  const pdpnMobileImagesSwiperWrapper = document.querySelector('.pdpn-mobile-swp_carrousel_images')
  const pdpnMobileImagesSlides = document.querySelectorAll('.pdpn-mobile-swp-images_slide')
  const secondMobileSlideIndex = 2

  let modelMobileSlideIndex
  pdpnMobileImagesSlides.forEach((slide, index) => {
    const imagenElement = slide.querySelector('.pdpn-mobile-images_container img')
    if (imagenElement) {
      const imageAlt = imagenElement.getAttribute('alt')
      if (imagenElement && imageAlt.includes('[model]')) {
        modelMobileSlideIndex = index + 1
      }
    }
  })

  if (modelMobileSlideIndex && modelMobileSlideIndex !== secondMobileSlideIndex) {
    const secondSlide = pdpnMobileImagesSwiperWrapper.querySelector(`[data-pdpn-mobile-images-slide-index="${secondMobileSlideIndex}"]`);
    const modelSlide = pdpnMobileImagesSwiperWrapper.querySelector(`[data-pdpn-mobile-images-slide-index="${modelMobileSlideIndex}"]`);

    pdpnMobileImagesSwiperWrapper.insertBefore(modelSlide, secondSlide);
  }

  // product-form-new-pdp
  // variable declaration
  const pdpnItemId = document.getElementById('pdpn-item-id');
  const pdpnItemSubmit = document.getElementById('pdpn-item-submit');

  //variables
  let sizeSelected = null;
  let colorSelected = null;
  let colorInputs = null
  // color
  const pdpnColorContainer = document.getElementById('pdpn-product__color-container');
  const pdpnColorTitle = document.querySelector('.pdpn-product__color-title');
  // const firstItemColor = pdpnColorContainer.querySelector('input');
  // const pdpnColorInputs = pdpnColorContainer.querySelectorAll('.pdpn-product__color-input');
  if (pdpnColorContainer) {
    colorSelected = pdpnColorContainer.querySelector('input').value;
    colorInputs = pdpnColorContainer.querySelectorAll('.pdpn-product__color-input');
  }

  // size
  const pdpnSizeContainer = document.getElementById('pdpn-product__size-container');
  const pdpnSizeInputContainer = document.querySelectorAll('.pdpn-product__size-container__input');
  // const firstItemSize = pdpnSizeContainer.querySelector('input');

  // variants
  const pdpnVariantOptions = document.getElementById('pdpn-variant-options_selected');
  const pdpnTitleProduct = document.querySelector('.pdpn-color-name');

  // gift-card
  const pdpnGiftCard = document.getElementById('pdpn-gift-card');

  // first load
  const swipers = initSwipers();

  const pdpnDeskImagesSwiper = swipers.swiperImagesDesktop;
  const pdpnMobileImagesSwiper = swipers.swiperImagesMobile;

  colorInputs?.forEach((colorInput) => {
    colorInput.addEventListener('click', (e) => {

      if (window.innerWidth <= 768) {
        const imagenId = colorInput.getAttribute('data-imagen-id');
        // Find the corresponding index in the main mobile carousel.
        const desktopSlideIndex = Array.from(pdpnMobileImagesSwiper.slides).findIndex(slide => {
          return slide.dataset.imageMobileId === imagenId;
        });
        // If the index is found, navigate to that slide in the main mobile carousel.
        if (desktopSlideIndex !== -1) {
          pdpnMobileImagesSwiper.slideTo(desktopSlideIndex);
        }

      } else {
        const imagenId = colorInput.getAttribute('data-imagen-id');

        const targetSlide = imagenId
          ? document.querySelector(`.pdpn-desktop-swp-images_slide[data-image-desktop-id="${imagenId}"]`)
          : null;
        // Scroll only inside the desktop images container to avoid scrolling the page body
        const imagesContainer = document.getElementById('pdpn-swp-desktop-images_container');
        if (targetSlide && imagesContainer) {
          const containerRect = imagesContainer.getBoundingClientRect();
          const slideRect = targetSlide.getBoundingClientRect();
          const offset = slideRect.top - containerRect.top + imagesContainer.scrollTop;
          imagesContainer.scrollTo({ top: offset, behavior: 'smooth' });
        }
      }
    });
  });


  function pdpnProductAvailable(colorInputs, sizeInputs, productData, variants, itemSubmit, giftCard) {
    function isColorAvailable(colorValue) {
      return productData.variants.some(variant => variant.option1 === colorValue && variant.available);
    }

    function updateTitleProduct(colorValue, availability) {
      if (pdpnTitleProduct) {
        pdpnTitleProduct.textContent = colorValue + (availability ? '' : ' - Sold Out');
      }
    }

    colorInputs?.forEach(colorInput => {
      const colorValue = colorInput.value;
      const colorAvailability = isColorAvailable(colorValue);
      const isSelectedColor = colorInput.checked;

      colorInput.dataset.productAvailable = colorAvailability ? 'true' : 'false';

      if (isSelectedColor) {
        updateTitleProduct(colorValue, colorAvailability);

        if (!colorAvailability) {
          itemSubmit.disabled = true;
          itemSubmit.value = 'Sold Out';
        }

        if (giftCard) {
          giftCard.textContent = colorValue;
        }

        //disclaimer OOS sizes
        let hasSwatchNotAvailableSizes = false;
        sizeInputs.forEach(sizeInput => {
          const sizeValue = sizeInput.value;
          const optionText = `${colorValue} / ${sizeValue}`;
          const option = Array.from(variants.options).find(opt => opt.text === optionText);

          if (option) {
            const checkAvailability = option.getAttribute('available');
            if (checkAvailability === 'false') {
              sizeInput.parentElement.querySelector('label').classList.add('not-available');
              hasSwatchNotAvailableSizes = true;
            }
          }
        });

        // disclaimer OOS sizes
        const disclaimerMainContainer = document.querySelector('.pdpn-main__container .title-disclaimer-container');
        const disclaimerContentContainers = document.querySelectorAll('.pdpn-main__container .title-disclaimer-container .disclaimer-oos-container');
        const disclaimerContentContainerMobile = disclaimerMainContainer && disclaimerMainContainer.querySelector('.disclaimer-oos-container.mobile-only');

        if ( disclaimerContentContainers && disclaimerMainContainer) {
          disclaimerContentContainers.forEach(disclaimerContainer => {
            if ( !hasSwatchNotAvailableSizes ) {
              disclaimerContainer.style.display = 'none';
              disclaimerMainContainer.classList.remove('padding-bottom');
            } else {
              disclaimerContainer.style.display = '';
              disclaimerContentContainerMobile?.classList.remove('show');
              disclaimerMainContainer.classList.remove('padding-bottom');
            }
          });
        }
      }
    });
  }


  function pdpnUpdateInputValue(color, size, dataSizes, variants, itemId, itemSubmit) {
    const dataColor = `${color}`;
    const dataColorSize = `${color} / ${size}`;

    //v2
    const findOption = (condition) => {
      const selectedOption = Array.from(variants?.options || []).find(option => condition(option));

      if (selectedOption) {
        const checkAvailability = selectedOption.getAttribute('available');
        selectedOption.selected = "selected";
        itemId.value = selectedOption.value;
        itemSubmit.disabled = checkAvailability !== 'true';
        itemSubmit.value = checkAvailability === 'true' ? 'Add to cart' : 'Sold Out';
      }
    };

    if (!dataSizes && color) {
      findOption(option => option.text === dataColor);
    } else if (color && size === null) {
      itemSubmit.value = 'Select Size';
      itemSubmit.disabled = true;
    } else {
      findOption(option => option.text === dataColorSize);
    }
  }

  pdpnUpdateInputValue(colorSelected, sizeSelected, itemsSizes, pdpnVariantOptions, pdpnItemId, pdpnItemSubmit);
  pdpnProductAvailable(colorInputs, pdpnSizeInputContainer, productInfo, pdpnVariantOptions, pdpnItemSubmit, pdpnGiftCard)

  pdpnColorContainer?.addEventListener("change", (e) => {
    colorSelected = e.target.value;
    pdpnSizeInputContainer.forEach((size) => {
      size.parentElement.querySelector('label').classList.remove('not-available');
    })

    pdpnUpdateInputValue(colorSelected, sizeSelected, itemsSizes, pdpnVariantOptions, pdpnItemId, pdpnItemSubmit);
    pdpnProductAvailable(colorInputs, pdpnSizeInputContainer, productInfo, pdpnVariantOptions, pdpnItemSubmit, pdpnGiftCard);
  })

  pdpnSizeContainer?.addEventListener('change', (e) => {
    sizeSelected = e.target.value;
    pdpnUpdateInputValue(colorSelected, sizeSelected, itemsSizes, pdpnVariantOptions, pdpnItemId, pdpnItemSubmit);
  })

  // Disclaimer to click on OOO sizes Optimization
  showDisclaimerSizesOOS();
});

// load elements
window.addEventListener('load', () => {
  baguetteBox.run('.new-product-content--sizechart')
  let sizechartElement = document.getElementById("baguetteBox-slider")
  sizechartElement.addEventListener('click', function () {
    baguetteBox.hide()
  })

  //afterpay
  setTimeout(()=>{
    let squarePlacementElement = document.querySelector('square-placement');
    const squarePlacementShadowRoot = squarePlacementElement.shadowRoot;
    const afterPayLogo = squarePlacementShadowRoot.querySelector('.afterpay-logo svg');
    const afterPayLink = squarePlacementShadowRoot.querySelector('.afterpay-link');
    if (afterPayLogo) afterPayLogo.setAttribute('style','width:70px;position:relative;left:-10px;');
    if (afterPayLink) afterPayLink.setAttribute('style','position:relative;left:-15px;');
  },300);
});
